<template>
  <div class="content-item">
    <h2 class="heading">Ordering cards</h2>
    <p class="text">
      Well you are off to a great start! Now it is time to work on your invitation cards. Please follow this link and follow the instructions. You must remember, we are customizing your cards, you are
      about to see a lot of different designs to choose from to help direct us in the customization process with our graphic design team.
    </p>
    <div class="radio-group">
      <div class="row">
        <p class="text"><a class="link-button" href="https://mytruelife.org/orderCards" target="_blank">Click Here</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
export default {
  name: 'Step4',
  props: {
    value: {
      type: Object,
    },
    source: {
      type: Object,
    },
  },
  computed: {
    backCards() {
      return get(this.source, 'back', []);
    },
  },
  data() {
    return {
      selected: {},
    };
  },
  methods: {
    doSelectCard(card) {
      this.$emit('onSelectCard', card);
    },
    doSetCardSelected(card) {
      this.selected = card;
      setTimeout(() => {
        this.$emit('onNextPage');
      }, 500);
    },
    submit() {
      this.$emit('input', {
        ...this.value,
        card_back: this.selected.id,
      });
    },
  },
};
</script>
